/* global toastr:false, moment:false */
(function() {
    'use strict';
    const production = true;
    angular
        .module('app.core')
        .constant('moment', moment)
        .constant('toastr', toastr)
        .constant('planillasVersion', 90)
        .constant('apiSettings', {  
            apiBaseUrl: production ? 'https://planillasrimag.linkpc.net/Planillas_WebApi/' : 'http://localhost/ITGPlanillas_RestAPI/'  
        });
})();
